<template>
  <div>
    <div class="wf-flex wf-items-center wf-mt-4">
      <button
        @click.prevent="toggleBottomSection"
        :class="hasBottomSection ? ['wf-bg-indigo-600 '] : ['wf-bg-gray-200']"
        class="wf-h-6 wf-w-6 wf-rounded wf-border wf-text-xs wf-items-center wf-flex wf-justify-center"
      ><i v-show="hasBottomSection" class="fas fa-check wf-text-white"></i></button>
      <span class="wf-ml-2 wf-text-xs wf-uppercase wf-font-bold wf-tracking-wide wf-text-gray-800">Bottom Section</span>
    </div>
  </div>
</template>

<script>
  import {SectionFactory} from '../../factories/SectionFactory'
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    computed: {
      hasBottomSection() {
        return !! this.$store.getters['bottomSectionModule/elements']()
      },
    },
    methods: {
      toggleBottomSection() {
        this.hasBottomSection ? this.removeBottomSection() : this.addBottomSection()
      },
      removeBottomSection() {
        this.addToObject('layoutModule', null, 'bottomSection')
      },
      addBottomSection() {
        this.addToObject('layoutModule', (new SectionFactory).create()[0], 'bottomSection')
      }
    }
  }
</script>